import { render } from "./DexBodyRow.vue?vue&type=template&id=cc9fe636"
import script from "./DexBodyRow.vue?vue&type=script&lang=js"
export * from "./DexBodyRow.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__